import { useRouter } from "next/router";
import CommonLayout from "./Common";
import NoFooterLayout from "./NoFooter";
import MinimalHeaderLayout from "./MinimalHeader";
import ProfileLayout from "./Profile";
import { ProfileProvider } from "@/providers/profile";
import AllenLogo from "@/components/SVG/AllenLogo";
import NoHeaderFooterLayout from "./NoHeaderFooter";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setStudentId } from "@/store/slices/auth";
import { getStudentIdLS } from "@/utils/auth";
import { getPageViewFields } from "@/utils";

const AppLayout = (props: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    const webStudentId = getStudentIdLS();
    if(!webStudentId){
      //@ts-ignore
      dispatch(setStudentId())
    }
  }, [])

  const pageProps = (props.children as any)?.[0]?.props?.children?.props;
  const pathName = router.asPath;
  useEffect(() => {
    if (!window?.dataLayer) {
      window.dataLayer = [];
    }
    const {pageType, pageViewFields} = getPageViewFields(pathName, pageProps);
    window.dataLayer.push({
      event: "custom_page_view",
      page_type: pageType,
      page_title: window.document.title,
      ...pageViewFields,
    });
  }, [router.asPath])

  if (router.asPath.startsWith("/allen-payment")) {
    return <NoHeaderFooterLayout>
      <div className="flex justify-center mb-6 p-4 bg-[#0f1825]">
        <AllenLogo className="h-8" />
      </div>
      {props.children}
    </NoHeaderFooterLayout>;
  }

  switch (router.pathname) {
    case "/allen-offline-event":
    case "/allen-offline-event-pdf":
    case "/allen-offline-event-feedback":
    case "/allen-distributor-up":
    case "/allen-aaa":
      return <NoHeaderFooterLayout>
        {props.children}
      </NoHeaderFooterLayout>;
    case "/checkout":
    case "/scholarship":
    case "/scholarship/[testId]/result":
    case "/testseries":
    case "/testseries/[testId]/result":
    case "/quiz/[groupId]":
    case "/counselling":
    case "/pro":
      return <NoFooterLayout>{props.children}</NoFooterLayout>;
    case "/scholarship/[testId]":
    case "/testseries/[testId]":
    case "/pdf-viewer":
      return <MinimalHeaderLayout>{props.children}</MinimalHeaderLayout>
    case "/change-pin":
    case "/profile":
    case "/saved-videos":
      return <CommonLayout>
        <ProfileProvider>
          <ProfileLayout>
            {props.children}
          </ProfileLayout>
        </ProfileProvider>
      </CommonLayout>
    default:
      return <CommonLayout>
        {props.children}
      </CommonLayout>;
  }
};

export default AppLayout;
